var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.style)},_vm._l((_vm.state.highlights),function(h,idx){return _c('div',{key:idx,staticClass:"annot8-hl",class:_vm.classH(h),style:(_vm.styleH(h)),attrs:{"data-id":h.id}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }